import template from "./fonds-beitrag-list-page.html.twig";

Packlab.Component.register('fonds-beitrag-list-page', {
    template,

});